import { getTodayEntry } from "./storage"
import { calculateCurrentStreak, getTodayDateString } from "./date-utils"
import { getEntries } from "./storage"

/**
 * Check if reminder banner should be shown
 * Returns true if:
 * - User hasn't logged an entry today
 * - User hasn't dismissed the reminder today
 */
export function shouldShowReminder(): boolean {
  if (typeof window === "undefined") return false

  const todayEntry = getTodayEntry()
  const today = getTodayDateString()
  const dismissedToday = localStorage.getItem(`reminder-dismissed-${today}`)

  return !todayEntry && !dismissedToday
}

/**
 * Dismiss reminder for today
 * User won't see the banner again until tomorrow
 */
export function dismissReminderForToday(): void {
  if (typeof window === "undefined") return

  const today = getTodayDateString()
  localStorage.setItem(`reminder-dismissed-${today}`, "true")
}

/**
 * Get current streak of consecutive days with entries
 * Uses the existing streak calculation from date-utils
 */
export function getStreakDays(): number {
  if (typeof window === "undefined") return 0

  const entries = getEntries()
  return calculateCurrentStreak(entries)
}
